module.exports = __webpack_public_path__ + "ca797216cd2be5bb7882fa423e41199a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/december-sale-banner.png
// module id = 527
// module chunks = 0